import { useContext } from 'react';
import { DEFAULT_THEME_NAME } from '../constants.js';
import { PolarisVizContext } from '../contexts/PolarisVizContext.js';
import { useChartContext } from './useChartContext.js';

function useTheme(passedTheme) {
  var _ref, _ref2;

  const {
    themes,
    defaultTheme
  } = useContext(PolarisVizContext);
  const {
    theme
  } = useChartContext();
  const themeName = (_ref = (_ref2 = passedTheme !== null && passedTheme !== void 0 ? passedTheme : theme) !== null && _ref2 !== void 0 ? _ref2 : defaultTheme) !== null && _ref !== void 0 ? _ref : DEFAULT_THEME_NAME;

  if (Object.prototype.hasOwnProperty.call(themes, themeName)) {
    return themes[themeName];
  } else {
    throw new Error(`${themeName} theme not found. Did you forget to define it in the PolarisVizProvider?`);
  }
}

export { useTheme };
